module.exports = __webpack_public_path__ + "static/media/card_bg_2.d849a130.png";